import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class AccountingManualJournalEntriesActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/AccountMove/AccountMoveBrowser")
	}

	render() {
		return (
			<Activity 
				name="AccountingManualJournalEntries"
				RenderedComponent={this.RenderedComponent}
				context="AccountingManualJournalEntries"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(AccountingManualJournalEntriesActivity)
